export default __webpack_public_path__ + "static/innotech-d51aa74c5877db20cc6fc5dcd860fb4c.png";